import React, { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import ClockIcon from 'icons/Clock.icon';
import XIcon from 'icons/X.icon';
import { getHasElementsInArray } from 'utils';

import './RecentSearchesList.styles.scss';

type RecentSearchesListProps = {
  className?: string;
  searches: string[];
  onSelect: (term: string) => void;
  onRemove: (term: string) => void;
  onClearAll: () => void;
};

const preventFocusLoss = (e: React.MouseEvent) => e.preventDefault();

const RecentSearchesList: FC<RecentSearchesListProps> = (props) => {
  const { className, searches, onSelect, onRemove, onClearAll } = props;

  const { t } = useTranslation();

  const classes = classNames('recent-searches-list', className);

  if (!getHasElementsInArray(searches)) return null;

  return (
    <div className={classes}>
      <span className="recent-searches-list__title">{t('recentSearches')}</span>

      <ul className="recent-searches-list__items">
        {searches.map((term) => (
          <li key={term}>
            <Button
              type="button"
              variant="link"
              icon={ClockIcon}
              className="recent-searches-list__term"
              onMouseDown={preventFocusLoss}
              onClick={() => onSelect(term)}
            >
              <span>{term}</span>
            </Button>

            <Button
              variant="link"
              icon={XIcon}
              aria-label={t('removeRecentSearch', { term })}
              className="recent-searches-list__remove"
              onMouseDown={preventFocusLoss}
              onClick={(e) => {
                e.stopPropagation();
                onRemove(term);
              }}
            />
          </li>
        ))}
      </ul>

      <Button
        variant="link"
        className="recent-searches-list__clear"
        onMouseDown={preventFocusLoss}
        onClick={onClearAll}
      >
        {t('clearRecentSearches')}
      </Button>
    </div>
  );
};

export default RecentSearchesList;
